import socket from "@/services/socket";
import {
  usePlayersStore,
  useSessionStore,
} from "@/stores";
import type {
  Player
} from "@/types";
export function handlePing([playerIdOrCount = 0, latency]: [
  (number | undefined)?,
  unknown?
] = []) {
  const session = useSessionStore();

  const now = Date.now();
  if (!session.isPlayerOrSpectator) {
    _cleanupDisconnectedPlayers(now);
    // store new player data
    if (playerIdOrCount) {
      socket.players[playerIdOrCount] = now;
      const ping = Number.parseInt(latency as string, 10);
      if (ping && ping > 0 && ping < 30 * 1000) {
        // ping to Players
        socket.pings[playerIdOrCount] = ping;
        const pings = Object.values(socket.pings);
        session.setPing(
          Math.round(pings.reduce((a, b) => a + b, 0) / pings.length)
        );
      }
    }
  } else if (latency) {
    // ping to ST
    session.setPing(Number.parseInt(latency as string, 10));
  }
  // update player count
  if (!session.isPlayerOrSpectator || playerIdOrCount) {
    const playerCount = session.isPlayerOrSpectator
      ? playerIdOrCount
      : Object.keys(socket.players).length;
    session.setPlayerCount(playerCount);
  }
}

function _cleanupDisconnectedPlayers(now: number) {
  const playersStore = usePlayersStore();

  // remove players that haven't sent a ping in 2.5 times the timespan
  for (let player in socket.players) {
    if (
      socket.players[player] &&
      now - socket.players[player] > socket.pingInterval * 2.5
    ) {
      delete socket.players[player];
      delete socket.pings[player];
    }
  }
  if (now - socket.connectedAt < socket.pingInterval * 2.5) return;
  playersStore.players.forEach((player: Player) => {
    if (player.id && !socket.players[player.id]) {
      playersStore.update({
        player,
        property: "id",
        value: "",
      });
    }
  });
}
